
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { useVideoManagement } from "@/hooks/useVideoManagement";
import VideoUploadDialog from "./VideoUploadDialog";
import VideoAnalysisDialog from "./VideoAnalysisDialog";
import VideoGrid from "./video-management/VideoGrid";
import EmptyState from "./video-management/EmptyState";
import LoadingState from "./video-management/LoadingState";

const VideoManagement: React.FC = () => {
  const {
    videos,
    loading,
    showUploadDialog,
    setShowUploadDialog,
    showAnalysisDialog,
    setShowAnalysisDialog,
    selectedVideo,
    handleDeleteVideo,
    handleUploadComplete,
    handleAnalyzeVideo,
    getFilenameFromUrl,
  } = useVideoManagement();

  return (
    <>
      <Card className="mt-6 bg-white/80 backdrop-blur-sm border border-blue-100 shadow-lg">
        <CardHeader>
          <div className="flex justify-between items-center">
            <div>
              <CardTitle>Video Analysis</CardTitle>
              <CardDescription>Upload and analyze football videos</CardDescription>
            </div>
            <Button onClick={() => setShowUploadDialog(true)}>
              <Upload className="mr-2 h-4 w-4" />
              Upload Video
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          {loading ? (
            <LoadingState />
          ) : videos.length > 0 ? (
            <VideoGrid
              videos={videos}
              onDelete={handleDeleteVideo}
              onAnalyze={handleAnalyzeVideo}
              getFilenameFromUrl={getFilenameFromUrl}
            />
          ) : (
            <EmptyState onUpload={() => setShowUploadDialog(true)} />
          )}
        </CardContent>
      </Card>

      <VideoUploadDialog
        showDialog={showUploadDialog}
        setShowDialog={setShowUploadDialog}
        onUploadComplete={handleUploadComplete}
      />

      <VideoAnalysisDialog
        showDialog={showAnalysisDialog}
        setShowDialog={setShowAnalysisDialog}
        selectedVideo={selectedVideo}
      />
    </>
  );
};

export default VideoManagement;
